<template>
  <div>
    <vs-loading :loading="loading"></vs-loading>

   

    <vs-card>
      <div slot="header">
        <div class="tw-flex tw-justify-between">
          <h3>Etkinliklerle ilgili Talep/Şikayet Formları</h3>

        </div>
      </div>

      <div class="tw-flex tw-flex-wrap">
        <div class="tw-w-full tw-flex tw-justify-between tw-items-center">
          <div class="tw-flex">
            <vs-input
                icon="mdi-magnify"
                placeholder="Arama"
                v-model="search"
  v-on:keyup.enter="page = 1; get();"
            />

           
          </div>

          
        </div>

        <div class="tw-w-full">
          <vs-divider></vs-divider>
        </div>

        <div class="tw-w-full lg:tw-w-2/2">
          <div v-if="loading">Yükleniyor...</div>

          <vs-table stripe :data="list">
            <template slot="header">
              <h3>Liste</h3>
            </template>
            <template slot="thead">
            
               <vs-th>Oluşturulma Tarihi</vs-th>
               
               
                <vs-th>Etkinlik Adı</vs-th>
                <vs-th>Etkinlik Birim</vs-th>
               <!--<vs-th>Sürdürülebilir Kalkınma Amaçları</vs-th> -->
                 <vs-th class="buyut1">Talep Türü</vs-th>
                 <vs-th  class="buyut1">Talep Görüldü mü?</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr v-for="(item, i) in data" :key="i" >
               
                 <vs-td :data="item.startDate">
                  <div class="fontt" @click="show(item, i)">{{ item.createdAt.substring(0,10) }}</div>
                </vs-td>
               
                 
                
                   <vs-td :data="item.eventName">
                  <div class="fontt" @click="show(item, i)">{{ item.eventName }}</div>
                </vs-td>
                <vs-td :data="item.eventName">
                  <div class="fontt2" @click="show(item, i)">{{ item.birim }}</div>
                </vs-td>
                  <!--<vs-td :data="item.relations">
                  <div class="fontt" @click="show(item, i)">{{ item.relations }}</div>-->
                     <vs-td :data="item.suggestRequest">
                      <div class="fontt" @click="show(item, i)">{{ item.suggestRequest }}</div>
                    </vs-td>
                
                   <vs-td  :data="item">
                    <vs-button  class="goruntule" color="#32bebe" icon-pack="mdi" icon="mdi-favorite" @click="goruntule(item)">Görüntüle</vs-button>
                  </vs-td>
              </vs-tr>
            </template>
          </vs-table>

          <!--<vs-button type="gradient" color="danger" @click="removeAll">Tümünü Sil</vs-button>-->
        </div>

        
      </div>

    </vs-card>

  </div>
</template>

<script>
  import { paginatorMixin } from "@/mixins/paginatorMixin";
  import Reqq from "@/libs/reqqs/Reqq";
         import { isAuthenticated, getUserFromStorage } from '@/utils/Customs'


  export default {
    name: "reqqs-index",
    title: "Dilek/Şikayet Görüntüle",

    mixins: [
      paginatorMixin,
    ],

    data() {
      return {
        obj: new Reqq(),
                         user: getUserFromStorage(),

        search: "",
        loading: false,
      };
    },

    computed: {
      reqqs() {
        return this.obj.reqqs
      },

      selected() {
        return this.obj.selected
      },

      saved() {
        return this.obj.saved
      },

      deleted() {
        return this.obj.deleted
      },

      list() {
        

        if(this.user.rol=="admin"){
          if(this.reqqs && this.reqqs.data){

                const etkinliklerim=this.reqqs.data
                const etkinliklerimTemp=[]


                for (let i = 0; i < etkinliklerim.length; i++) {
                  
                  if(etkinliklerim[i].published != "Silindi"){
                      etkinliklerimTemp.push(etkinliklerim[i]);
                  }
                }
                

                return etkinliklerimTemp
                }
          
        }
        else{
          if(this.reqqs && this.reqqs.data){

                const etkinliklerim=this.reqqs.data
                const etkinliklerimTemp=[]


                for (let i = 0; i < etkinliklerim.length; i++) {
                  console.log(etkinliklerim.birim)
                  if(etkinliklerim[i].birim == this.user.unit ){
                      etkinliklerimTemp.push(etkinliklerim[i]);
                  }
                }
                

                return etkinliklerimTemp
                }
        }  

        return []
      },

      meta() {
        if(this.reqqs && this.reqqs.meta)
          return this.reqqs.meta

        return null
      },

      submitted() {
        return this.obj.form.submitted
      },

      contaminated() {
        return this.obj.form.errorDetected
      }
    },

    watch: {
      contaminated(val) {
        this.loading = false
      },

      submitted(val) {
        if(val)
          this.loading = false
      },

      saved(val) {
        if(val)
          this.get()
      },

      deleted(val) {
        if(val)
          this.get()
      },
    },
 
    methods: {
      goruntule(item){
        this.$router.push({name: 'reqqs-show', params: {id: item.id}})

      },
      get() {
        const params = this.getRequestParams(
          this.search,
          this.page,
          10
        );

        this.loading = true
        this.obj.getAll(params)
      },

      handlePageChange(page) {
        this.page = page;
        this.get();
      },

      handlePageSizeChange() {
        this.page = 1;
        this.get();
      },

      refreshList() {
        this.get();
        this.obj.selected = null;
      },

      show(item, index) {
        this.obj.selected = item;
      },

      removeAll() {
        this.loading = true
        this.obj.deleteAll()
      },
    },
    
    mounted() {
      this.get();
    }
  };
</script>

<style>
  .vs-component.vs-button.vs-button-danger.vs-button-gradient{
    color:white;
  }
  .vs-component.vs-button.vs-button-primary.vs-button-filled{
    color:white;
  }
  .vs-component.vs-button.vs-button-null.vs-button-filled{
    color:white;
  }
  .sagaAlabilirmiyiz{
    margin-left:20%;
  }
  .goruntule{
   
      width:50% !important;
    
    
  }
  .fontt2{
    width:70%;
  }
  .buyut1{
    width:20% !important;
  }
</style>